import React from "react";
import { Box, Typography } from "@mui/material";
import type { SummaryLine } from "../../domain/askNoticeboard/catalogue";

/** A task's summary card: what Ask Noticeboard understood, and its buttons (Open to review, or Looks good and Cancel). */
const HandoffCard: React.FC<{
  summary: SummaryLine[];
  children?: React.ReactNode;
}> = ({ summary, children }) => (
  <Box
    component="section"
    aria-label="What I understood"
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      p: 2,
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 2,
      bgcolor: "background.default",
    }}
  >
    <Box
      component="dl"
      sx={{
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        columnGap: 2,
        rowGap: 0.5,
        m: 0,
      }}
    >
      {summary.map(({ label, value }) => (
        <React.Fragment key={label}>
          <Typography component="dt" variant="body2" sx={{ color: "text.secondary" }}>
            {label}
          </Typography>
          {/* A Poll's choices are one to a line */}
          <Typography component="dd" variant="body2" sx={{ m: 0, fontWeight: 600, whiteSpace: "pre-line" }}>
            {value}
          </Typography>
        </React.Fragment>
      ))}
    </Box>
    {children && <Box sx={{ display: "flex", gap: 1 }}>{children}</Box>}
  </Box>
);

export default HandoffCard;
